<div class="fc-dropdown">
    <label class="dropdown-label" *ngIf="floatLabel==='auto' ? dropdownLabel && selectedItems.length : floatLabel!=='never'">
        {{ dropdownLabel }}
    </label>
    <button type="button"
            #dropdownButton
            class="toggle-button"
            (click)="toggleDropdown()"
            [title]="populateDropdownTooltip()"
            [disabled]="disabled"
            aria-expanded="true" aria-haspopup="true">
        <span #dropdownButtonLabel [ngClass]="{'has-selected': hasSelected}"
              class="truncate">{{ populateDropdownLabel() }}</span>
    </button>
    <ng-container *ngTemplateOutlet="!isMobileMode ? desktopMode : null"></ng-container>
</div>
<ng-container *ngTemplateOutlet="isMobileMode ? mobileMode : null"></ng-container>
<ng-template #desktopMode>
    <div [hidden]="!isDropdownOpen"
         #dropdownPanel
         class="item-panel"
         role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
        <ng-container *ngTemplateOutlet="panelTemplate"></ng-container>
    </div>
</ng-template>
<ng-template #mobileMode>
    <div [hidden]="!isDropdownOpen" class="mobile-mode-wrapper">
        <div #mobileModeHeader class="wrapper-header">
            <button type="button" class="dismiss" (click)="toggleDropdown(); $event.preventDefault()"></button>
            <span class="header-title">{{ dropdownPlaceholder }}</span>
        </div>
        <ng-container *ngTemplateOutlet="panelTemplate"></ng-container>
    </div>
</ng-template>
<ng-template #panelTemplate>
    <div #searchContainer class="search-wrapper" [hidden]="!searchEnabled">
        <input class="item-search"
               #searchInput
               [ngModel]="searchTerm"
               [placeholder]="FILTER_PLACEHOLDER"
               (ngModelChange)="searchTermChange($event)"
               aria-autocomplete="list"
               type="search">
    </div>
    <hr>
    <div #selectionHelper class="selection-helper"
         (click)="selectAllHandler(); $event.preventDefault();$event.stopPropagation()"
         *ngIf="isMultiselect">
        <label class="checkbox-container">
            <input class="checkbox-input" [checked]="isSelectAll" type="checkbox" readonly>
            <span class="checkmark" [ngClass]="{'all-checked': isSelectAll}"></span>
        </label>
        <span class="select-all-label">{{ selectAllLabel }}</span>
    </div>
    <hr>
    <div class="item-list" role="none">
        <fc-virtual-scroller
                [ngStyle]="populateVirtualScrollerStyle()"
                [bufferAmount]="10"
                #fcVirtualScroller [items]="viewportItems">
            <ng-container *ngFor="let item of fcVirtualScroller.viewPortItems;index as i">
                <div 
                    [ngClass]="(item[selectedKey] && !isMultiselect) ? 'selected' : ''"
                    [class.disabled]="item._disabled"
                    (click)="toggleSelection(item); $event.preventDefault();"
                    class="item">
                    <ng-container *ngTemplateOutlet="(customItemTpl ? customItemTpl : defaultItemTpl); context: { item, thiz: this}"></ng-container>
                </div>
            </ng-container>
            <ng-template #defaultItemTpl let-item="item">
                <label class="checkbox-container" *ngIf="isMultiselect">
                    <input class="checkbox-input" type="checkbox" [checked]="item[selectedKey]" readonly>
                    <span class="checkmark item-checked"></span>
                </label>
                <span class="item-label" [title]="item[bindLabel]">
                    {{ item[bindLabel] }}
                </span>
            </ng-template>
        </fc-virtual-scroller>
    </div>
</ng-template>
